export const resultColors = {
  main: { text: "#004990", bar: "#c3e5ec", background: "#ebf5f7" },
  secondary: { text: "black", bar: "#dddddd", background: "#F6F6F6" },
};
